jQuery(document).ready(function($) {
  function currency_convert (amount, cur1, cur2) {
    fx.base = cur1;
    fx.settings = {
      from : cur1
    };

    var amount = 9.99; //in SolidShops, you could use: {{ product.price }}
    // Load exchange rates data via the cross-domain/AJAX proxy:

    $.getJSON(
      'http://openexchangerates.org/latest.json',
      function(data) {
        // Check money.js has finished loading:
        if ( typeof fx !== "undefined" && fx.rates ) {
          fx.rates = data.rates;
          fx.base = data.base;
        } else {
          // If not, apply to fxSetup global:
          var fxSetup = {
            rates : data.rates,
            base : data.base
          }
          }

        // now that we have exchange rates, add a few to our page
        var converted_amount = fx.convert(amount, {to: cur2}); 

        // we can now use the accounting.js library to format the numbers properly
        converted_amount = accounting.formatMoney(converted_amount, "$ ", 2, ",", ".");

        console.log(converted_amount);
      }
    );
  };
  
  $(".product__addon select[data-product-add-select]").change(function(e) {
    console.log($(this).find("option:selected").attr("data-product-addon-price"));
    var addon_price = 0;
    if ($(this).find("option:selected").attr("data-product-addon-price")) {
      var addon_price = parseFloat($(this).find("option:selected").attr("data-product-addon-price"));
    }

    if(addon_price == 0) {
      return 0;
    }

    var original_price = parseFloat($(".product_price .price .money").attr("doubly-currency-cad"));
    var tot_price = original_price + addon_price;
    console.log(original_price);
    console.log(addon_price);

    currency_convert(tot_price, "CAD", "USD");

    $(".product_price .price .money").attr("doubly-currency-cad", tot_price);

    return addon_price;
  });
  
  $(".product #ZlistWishlist label").click(function(e) {
    $(this).addClass("clicked");
    var btn = $(this);
    
    setTimeout(function() {
      btn.removeClass("clicked");
    }, 3000);
  });
});